import { combineReducers } from 'redux'
import auth from './auth'
import locale from './locale/localeSlice'
import listData from './data/dataSlice'

const rootReducer = asyncReducers => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        locale,
        listData,
        // stripe: require('../views/stripe/store').default,
        // subscription: require('../views/subscription/store').default,
        subscription_pivot: require('../views/manage-product-subscription/store').default,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
